export default "__VITE_ASSET__q5fcy4$A__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsClassicFormCarla&nuxt_component_export=default__"